import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        pageNumber: undefined,
        totalPages: undefined
    },
    buildingList: [],
    //form specific:
    buildingData: {},

    loading: false,
    loadingListRequest: false,
    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    buildingWasCreated: false,
    buildingWasEdited: false,
    buildingWasDeleted: false,

    error: undefined
};

const buildingsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.GET_BUILDING_LIST_REQUEST:
            return {
                ...state,
                loadingListRequest: true
            };
        case actionTypes.GET_BUILDING_LIST_SUCCESS:
            return {
                ...state,
                loadingListRequest: false,
                buildingList: payload
            };
        case actionTypes.GET_BUILDING_LIST_FAILED:
            return {
                ...state,
                loadingListRequest: false,
            };
        case actionTypes.BUILDING_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.BUILDING_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_BUILDING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_BUILDING_SUCCESS:
            return {
                ...state,
                loading: false,
                buildingData: payload
            };
        case actionTypes.GET_BUILDING_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.CREATE_BUILDING_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_BUILDING_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                buildingWasCreated: true
            };
        case actionTypes.CREATE_BUILDING_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                buildingWasCreated: false
            };
        case actionTypes.EDIT_BUILDING_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_BUILDING_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                buildingWasEdited: true
            };
        case actionTypes.EDIT_BUILDING_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                buildingWasEdited: false
            };
        case actionTypes.DELETE_BUILDING_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_BUILDING_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                buildingWasDeleted: true
            };
        case actionTypes.DELETE_BUILDING_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                buildingWasDeleted: false
            };
        case actionTypes.RESET_BUILDINGS_FORM:
            return {
                ...state,
                buildingData: {},
                loading: false,
                loadingListRequest: false,
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                buildingWasCreated: false,
                buildingWasEdited: false,
                buildingWasDeleted: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default buildingsReducer;